// extracted by mini-css-extract-plugin
export var activeCategory = "partners-module--activeCategory--BSWyd";
export var category = "partners-module--category--ueK6b";
export var categoryList = "partners-module--categoryList--J-NNr";
export var container = "partners-module--container--t-bGH";
export var description = "partners-module--description--Wjtgj";
export var errorShops = "partners-module--errorShops--B+QJc";
export var headDescr = "partners-module--headDescr--xdwUu";
export var headTitle = "partners-module--headTitle--YY1yE";
export var logo = "partners-module--logo--MoSAe";
export var p_0 = "partners-module--p_0--xb3Yo";
export var slide = "partners-module--slide--1EHL0";
export var subTitlePartners = "partners-module--subTitlePartners--2Z6M2";
export var text = "partners-module--text--nxxwb";
export var title = "partners-module--title--nDLoj";
export var title_container = "partners-module--title_container--JvAe5";